import { render, staticRenderFns } from "./bottom-navigation-component.vue?vue&type=template&id=607ba5c3&scoped=true&"
import script from "./bottom-navigation-component.vue?vue&type=script&lang=ts&"
export * from "./bottom-navigation-component.vue?vue&type=script&lang=ts&"
import style0 from "./bottom-navigation-component.vue?vue&type=style&index=0&id=607ba5c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607ba5c3",
  null
  
)

export default component.exports